var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "safe-area-inset-bottom" }, [
      _c("img", {
        attrs: { src: require("@/assets/images/success1.jpeg"), alt: "" }
      }),
      _c("img", {
        attrs: { src: require("@/assets/images/success2.jpeg"), alt: "" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }